import { Answer, Question } from '@dreryk/egabinet-survey-frontend-api';

import { PreInterviewItem } from './PreInterviewPreviewItem.types';

export const mapPreInterviewItems = (questions: Question[], answers: Answer[]): PreInterviewItem[] => {
   const answerMap = new Map(answers.map((answer) => [answer.questionId, answer.content]));

   return questions.map((question) => ({
      id: question.id,
      questionNumber: question.questionNumber,
      questionContent: question.content,
      answerContent: answerMap.get(question.id),
   }));
};
